import { toast } from 'react-toastify';
import { axios } from '../../utils/axios';
import { toastOptions } from '../../config/toast';
import { format, parse } from 'date-fns';

export const handleBuscarActasPorArticulo = async (submittedData, setData, setFechasBusqueda) => {
  const result = await axios().post('actas_por_articulo', submittedData);
  const { status } = result;
  const { data, error } = result.data;

  if (data && data.length > 0) {
    setData(data);
    setFechasBusqueda({
      fecha_inicio: format(parse(submittedData.fecha_inicio, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy'),
      fecha_fin: format(parse(submittedData.fecha_fin, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy'),
    });
  } else {
    toast.info('No hay actas en ese rango de fechas', toastOptions);
  }

  if (error) {
    if (status !== 422) {
      toast.error(error, toastOptions);
    } else {
      Object.values(error).map((err) => toast.error(err[0], toastOptions));
    }
  }
};
